module.exports = __webpack_public_path__ + "img/emoji_107.5398fbb8.png";